module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/zh-hant/6-d9a9deb5b2ea2e2607d7be3df77e631c.jpg";